import * as React from "react";
const AbandonedCart = (props) => (
  <svg
    width={34}
    height={33}
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_di_6515_2247)">
      <g clipPath="url(#clip0_6515_2247)">
        <rect x={1} width={32} height={32} rx={8} fill="#27272A" />
        <g clipPath="url(#clip1_6515_2247)" filter="url(#filter1_dd_6515_2247)">
          <path
            d="M14.6004 23.9999C14.6004 24.8799 13.8804 25.5999 13.0004 25.5999C12.1204 25.5999 11.4004 24.8799 11.4004 23.9999C11.4004 23.1199 12.1204 22.3999 13.0004 22.3999C13.8804 22.3999 14.6004 23.1199 14.6004 23.9999ZM21.0004 22.3999C20.1204 22.3999 19.4004 23.1199 19.4004 23.9999C19.4004 24.8799 20.1204 25.5999 21.0004 25.5999C21.8804 25.5999 22.6004 24.8799 22.6004 23.9999C22.6004 23.1199 21.8804 22.3999 21.0004 22.3999ZM25.6484 14.0639C24.7764 15.2399 23.3764 15.9999 21.8004 15.9999C19.1524 15.9999 17.0004 13.8479 17.0004 11.1999C17.0004 10.3279 17.2324 9.5039 17.6404 8.7999H10.7924L10.7604 8.5199C10.6164 7.3119 9.59239 6.3999 8.37639 6.3999H7.40039V7.9999H8.37639C8.78439 7.9999 9.12039 8.3039 9.16839 8.7039L10.4324 19.4799C10.5764 20.6879 11.6004 21.5999 12.8164 21.5999H23.3924V19.9999H12.8244C12.4164 19.9999 12.0804 19.6959 12.0324 19.2959L11.9284 18.3999H24.8724L25.6564 14.0639H25.6484ZM24.2004 10.3999H19.4004V11.9999H24.2004V10.3999Z"
            fill="url(#paint0_linear_6515_2247)"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_di_6515_2247"
        x={0.6}
        y={0}
        width={32.8}
        height={32.8}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.4} />
        <feGaussianBlur stdDeviation={0.2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6515_2247"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_6515_2247"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.4} />
        <feGaussianBlur stdDeviation={0.2} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_6515_2247"
        />
      </filter>
      <filter
        id="filter1_dd_6515_2247"
        x={-22.5996}
        y={-19.7016}
        width={79.1992}
        height={79.2}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={10} />
        <feGaussianBlur stdDeviation={10} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6515_2247"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3.89851} />
        <feGaussianBlur stdDeviation={15} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6515_2247"
          result="effect2_dropShadow_6515_2247"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6515_2247"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6515_2247"
        x1={7.25934}
        y1={2.45493}
        x2={21.44}
        y2={22.2184}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <clipPath id="clip0_6515_2247">
        <rect x={1} width={32} height={32} rx={8} fill="white" />
      </clipPath>
      <clipPath id="clip1_6515_2247">
        <rect
          width={19.2}
          height={19.2}
          fill="white"
          transform="translate(7.40039 6.3999)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default AbandonedCart;
